import * as React from 'react'
import { Container, FormControl, FormControlLabel, FormLabel, Grid2, Radio, RadioGroup, Typography } from '@mui/material'
import ModernNavbar from '../setup/ModernNavbar'
import Autocomplete from '../../BuiltInComponent/AutoComplete'
import { useDispatch, useSelector } from 'react-redux'
import { getAllUsers, getAllMenus, getUserRights, getMobileRights, syncMobileAccess, updateMobileRights, updateUserRights } from '../../features/AdminManagement/setUserRightsSlice'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField } from '@mui/material';
import { useTheme } from '@emotion/react';
import Switch from '@mui/material/Switch';
import ButtonNormal from '../../BuiltInComponent/ButtonNormal'

export default function SetUserRights() {
    const dispatch = useDispatch()
    const { allUsers, userRights, mobileRights, isLoading } = useSelector(state => state.sur)
    const [userRightsData, setUserRightsData] = React.useState([])
    const [mobileRightsData, setMobileRightsData] = React.useState([])
    const [userID, setUserID] = React.useState('')
    const [mobileAccess, setMobileAccess] = React.useState(true)
    const tableColumns = [
        { fieldName: 'menuID', cName: 'Menu ID', width: 10, textAlign: 'left', status: 'en' },
        { fieldName: 'headMenu', cName: 'Parent Menu', width: 10, textAlign: 'left', status: 'en' },
        { fieldName: 'subMenu', cName: 'Menu Name', width: 10, textAlign: 'left', status: 'en' },
        { fieldName: 'allowed', cName: 'Allow', width: 10, textAlign: 'center', status: 'en', swithButton: true },
        { fieldName: 'edit', cName: 'Edit', width: 10, textAlign: 'center', status: 'di' },
        { fieldName: 'delete', cName: 'Delete', width: 10, textAlign: 'center', status: 'di' },
    ]

    React.useEffect(() => {
        dispatch(getAllUsers()).then(() => {
            dispatch(getAllMenus())
        })
    }, [dispatch])

    const webRightsBulkValue = React.useMemo(() => {
        if (!userRightsData || userRightsData.length === 0) {
            return ''
        }

        const allowedCount = userRightsData.filter((item) => item.allowed === true).length

        if (allowedCount === userRightsData.length) {
            return 'allow'
        }

        if (allowedCount === 0) {
            return 'deny'
        }

        return ''
    }, [userRightsData])

    const onChange = (data) => {
        if (!data) {
            setUserID('')
            setUserRightsData([])
            setMobileRightsData([])
            return
        }

        const keys = Object.keys(data)
        // setMenuData(prevData => ({
        //     ...prevData, [keys]: data[keys]
        // }))
        console.log(data[keys])
        if (keys[0] === 'userID') {
            setUserID(data[keys])
            const selectedUser = (allUsers || []).find((u) => u.userID === data[keys])
            if (selectedUser) {
                const normalized = String(selectedUser.userStatus ?? '').toLowerCase()
                setMobileAccess(['1', 'true', 'active', 'enabled', 'yes'].includes(normalized) || normalized === '')
            }
            dispatch(getUserRights({ userID: data[keys] }))
                .then((response) => {
                    console.log(response.payload)
                    setUserRightsData(response.payload || userRights);
                })
            dispatch(getMobileRights({ userID: data[keys] }))
                .then((response) => {
                    setMobileRightsData(response.payload || mobileRights)
                })
        }
    }
    const onChangeSwitch = (updatedRow) => {
        setUserRightsData((prevData) =>
            prevData.map((row) =>
                row.subMenu === updatedRow.subMenu
                    ? { ...row, allowed: !row.allowed }
                    : row
            )
        )
    }
    const onClickUpdateUserRights = () => {
        dispatch(updateUserRights(userRightsData))
            .then((response) => {
                setUserRightsData(response.payload || []);
            })
    }

    const onChangeWebRightsBulk = (event) => {
        const nextValue = event.target.value

        if (!nextValue) {
            return
        }

        setUserRightsData((prevData) => prevData.map((row) => ({
            ...row,
            allowed: nextValue === 'allow'
        })))
    }

    const onChangeMobileSwitch = (updatedRow) => {
        setMobileRightsData((prevData) =>
            prevData.map((row) =>
                row.key === updatedRow.key
                    ? { ...row, allowed: !row.allowed }
                    : row
            )
        )
    }

    const onClickUpdateMobileRights = () => {
        dispatch(updateMobileRights(mobileRightsData))
    }

    const onClickSyncMobileAccess = async () => {
        if (!userID) {
            alert('Please select a user first.')
            return
        }

        const selectedUser = (allUsers || []).find((u) => u.userID === userID)
        if (!selectedUser?.userName) {
            alert('The selected user is invalid.')
            return
        }

        const resultAction = await dispatch(syncMobileAccess({
            userName: selectedUser.userName,
            isActive: mobileAccess
        }))

        if (syncMobileAccess.fulfilled.match(resultAction)) {
            alert(`Mobile access was synced successfully for ${selectedUser.userName}.`)
        } else {
            alert(resultAction.payload || 'Unable to sync mobile access settings.')
        }
    }
    return (
        <>
            <ModernNavbar />
            <Container>
                <Typography>Set User Rights</Typography>
                <Grid2 container spacing={2}>
                    <Grid2 size={4}>
                        <Autocomplete
                            listData={allUsers && allUsers}
                            value={allUsers.find((c) => c.userID === userID)}
                            onChange={onChange}
                            label='Select User'
                        />
                    </Grid2>
                    <Grid2 size={4}></Grid2>
                    <Grid2 size={4}>
                        <ButtonNormal onClick={onClickUpdateUserRights} text='Update Rights' />
                    </Grid2>
                    <Grid2 size={12}>
                        <FormControl>
                            <FormLabel>Web Menus Bulk Rights</FormLabel>
                            <RadioGroup row value={webRightsBulkValue} onChange={onChangeWebRightsBulk}>
                                <FormControlLabel value="allow" control={<Radio />} label="Allow All" disabled={!userID || userRightsData.length === 0} />
                                <FormControlLabel value="deny" control={<Radio />} label="Deny All" disabled={!userID || userRightsData.length === 0} />
                            </RadioGroup>
                        </FormControl>
                    </Grid2>
                    <Grid2 size={6}>
                        <FormControlLabel
                            control={<Switch checked={mobileAccess} onChange={(e) => setMobileAccess(e.target.checked)} disabled={!userID} />}
                            label={mobileAccess ? 'Mobile Access Enabled' : 'Mobile Access Disabled'}
                        />
                    </Grid2>
                    <Grid2 size={6}>
                        <ButtonNormal
                            onClick={onClickSyncMobileAccess}
                            text={isLoading ? 'Syncing...' : 'Sync Mobile Access'}
                            disabled={!userID || isLoading}
                        />
                    </Grid2>
                    <Grid2 size={12}>
                        <StickyHeadTable tableColumns={tableColumns} tableData={userRightsData || []} perPage={50} onChangeSwitch={onChangeSwitch} />
                    </Grid2>
                    <Grid2 size={8}>
                        <Typography sx={{ mt: 2, fontWeight: 700 }}>Mobile Rights</Typography>
                    </Grid2>
                    <Grid2 size={4}>
                        <ButtonNormal onClick={onClickUpdateMobileRights} text='Update Mobile Rights' />
                    </Grid2>
                    <Grid2 size={12}>
                        <MobileRightsTable rows={mobileRightsData || []} onChangeSwitch={onChangeMobileSwitch} />
                    </Grid2>
                </Grid2>
            </Container>
        </>
    )
}

function MobileRightsTable({ rows, onChangeSwitch }) {
    return (
        <Paper sx={{ width: '98%', overflow: 'hidden', backgroundColor: 'rgb(250, 250, 250)', mt: 2 }}>
            <TableContainer>
                <Table stickyHeader aria-label="mobile-rights-table" size='small'>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold' }}>Mobile Feature</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Description</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Allowed</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.key}>
                                <TableCell>{row.label}</TableCell>
                                <TableCell>{row.description}</TableCell>
                                <TableCell>
                                    <Switch checked={Boolean(row.allowed)} onChange={() => onChangeSwitch(row)} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}




function StickyHeadTable(props) {

    const theme = useTheme()

    const perPage = props.perPage
    const tableColumns = props.tableColumns
    const rows = props.tableData
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(perPage || 5);
    const [filter, setFilter] = React.useState(''); // New state for filtering
    const [filteredRows, setFilteredRows] = React.useState(rows); // New state to hold filtered data

    // Handle pagination
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    // Handle the filter input change
    const handleFilterChange = (event) => {
        const filterValue = event.target.value.toLowerCase();
        setFilter(filterValue);

        // Filter rows based on filter input
        const filteredData = rows.filter(row => {
            return tableColumns.some(col => {
                const cellValue = row[col.fieldName]?.toString().toLowerCase();
                return cellValue && cellValue.includes(filterValue);
            });
        });

        setFilteredRows(filteredData);
    };

    React.useEffect(() => {
        setFilteredRows(rows); // Update filteredRows if rows change
    }, [rows]);

    const tableHeadStyle = {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        textAlign: `left`,
        fontWeight: 'bolder',
        width: `40%`,
        textShadow: 'black 2px 2px 4px'
    }
    const handleSwitchChange = (index) => {
        const updatedRows = [...rows];
        updatedRows[index] = {
            ...updatedRows[index],
            allowed: !updatedRows[index].allowed // Toggle the allowed key
        };
        props.onChangeSwitch(updatedRows[index]); // Notify the parent component of the change
        setFilteredRows(updatedRows);
        const onChangeSwitchFunc = props.onChangeSwitch
        onChangeSwitchFunc(filteredRows)
        // console.log(filteredRows)
    };
    return (
        <Paper sx={{ width: '98%', overflow: 'hidden', backgroundColor: 'rgb(250, 250, 250)' }}>
            <Grid2 container spacing={1}>
                <Grid2 size={4}></Grid2>
                <Grid2 size={4}>
                    <TextField
                        sx={{ margin: '20px' }}
                        label="Filter"
                        variant="outlined"
                        fullWidth
                        value={filter}
                        onChange={handleFilterChange}
                        placeholder="Search by any column..."
                        size='small'
                    />
                </Grid2>
                <Grid2 size={4}></Grid2>
            </Grid2>
            <TableContainer sx={{ maxHeight: 450 }}>
                <Table stickyHeader aria-label="sticky table" size='small'>
                    <TableHead>
                        <TableRow>
                            <TableCell key={Math.random()} style={tableHeadStyle}>Menu Head Description</TableCell>
                            <TableCell key={Math.random()} style={tableHeadStyle}>Menu Description</TableCell>
                            <TableCell key={Math.random()} style={tableHeadStyle}>Menu Allowed / Not</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredRows && filteredRows
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, rowIndex) => {
                                return (
                                    <TableRow
                                        key={rowIndex}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        style={{ width: '70%', }}
                                    >
                                        <TableCell key={Math.random()} style={{ textAlign: `left` }} component="th" scope="row">
                                            {row.headMenu}
                                        </TableCell>
                                        <TableCell key={Math.random()} style={{ textAlign: `left` }} component="th" scope="row">
                                            {row.subMenu}
                                        </TableCell>
                                        <TableCell key={Math.random()} style={{ textAlign: `left` }} component="th" scope="row">
                                            <Switch checked={row.allowed} onChange={() => handleSwitchChange(rowIndex)} />
                                        </TableCell>

                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[50, 100, 200]}
                component="div"
                count={filteredRows && filteredRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}
